export const visit = (vm, at) => {
vm(require("foundations-components/lang/nl.lyaml"));
at({ "nl": { "placeholder": "tijdelijke aanduiding" } });
};